import React from 'react';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const DailyRecommendationSkeleton = props => (
  <div className="recommendations-container">
    <div id="rec_grid_items_1">
      <div className=" card_height" />
      {[...Array(1)].map((e, i) => (
        <div className=" card_height" key={i}>
          <Skeleton borderRadius="1rem" height="130px" width="100%" margin="0" />
        </div>
      ))}
    </div>
    <hr className="grid_item_border" />
    <div id="rec_grid_items_2">
      <div className=" card_height" />

      {[...Array(1)].map((e, i) => (
        <div className=" card_height" key={i}>
          <Skeleton borderRadius="1rem" height="130px" width="100%" margin="0" />
        </div>
      ))}
    </div>
    <hr className="grid_item_border" />

    <div id="rec_grid_items_3">
      {[...Array(3)].map((e, i) => (
        <div className=" card_height" key={i}>
          <Skeleton borderRadius="1rem" height="130px" width="100%" margin="0" />
        </div>
      ))}
    </div>
    <hr className="grid_item_border" />

    <div id="rec_grid_items_4">
      <div className=" card_height" />

      {[...Array(1)].map((e, i) => (
        <div className=" card_height" key={i}>
          <Skeleton borderRadius="1rem" height="130px" width="100%" margin="0" />
        </div>
      ))}
    </div>
    <hr className="grid_item_border" />
    <div id="rec_grid_items_5">
      <div className=" card_height" />

      {[...Array(2)].map((e, i) => (
        <div className=" card_height" key={i}>
          <Skeleton borderRadius="1rem" height="130px" width="100%" margin="0" />
        </div>
      ))}
    </div>
    <hr className="grid_item_border" />

    <div id="rec_grid_items_6">
      <div className=" card_height" />

      {[...Array(1)].map((e, i) => (
        <div className=" card_height" key={i}>
          <Skeleton borderRadius="1rem" height="130px" width="100%" margin="0" />
        </div>
      ))}
    </div>
    <hr className="grid_item_border" />

    <div id="rec_grid_items_7">
      <div className=" card_height" />

      {[...Array(2)].map((e, i) => (
        <div className=" card_height" key={i}>
          <Skeleton borderRadius="1rem" height="130px" width="100%" margin="0" />
        </div>
      ))}
    </div>
  </div>
);
export default DailyRecommendationSkeleton;
